import { defineEffect } from '../../../core/effect';
import { attackSpec } from '../fx/attack';

/** 攻撃宣言（直接攻撃）（Issue #589。状況は共通側の `editorPorts/duelSituations/attack.js` が決め、絵の組み立ては `../fx/attack.js`） */
export default defineEffect({ situation: 'attack_direct', role: 'effect', ...attackSpec(true) }, 'attack_direct_effect.js');
